import React, { useMemo } from "react";

export const Embers = ({ count = 20, className = "" }) => {
  const embers = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const size = 2 + Math.random() * 6;
      return {
        id: i,
        left: Math.random() * 100,
        size,
        delay: Math.random() * 12,
        duration: 10 + Math.random() * 18,
      };
    });
  }, [count]);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {embers.map((e) => (
        <span
          key={e.id}
          className="ember"
          style={{
            left: `${e.left}%`,
            width: `${e.size}px`,
            height: `${e.size}px`,
            animationDelay: `${e.delay}s`,
            animationDuration: `${e.duration}s`,
          }}
        />
      ))}
    </div>
  );
};
